//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {fetchFilter} from "@/api/master";
import {fetchMoneyTransferList} from "@/api/moneyTransfer"
import {Message} from "element-ui";
import func from "@/utils/decoded";
import {fetchReportStep5} from "@/api/report";
import moment from "moment/moment";

const fields = [
	{key: 'contract_id', label: 'เลขที่สัญญา', _style: 'min-width:100px'},
	{key: 'name_customer', label: 'ชื่อ-สกุล', _style: 'min-width:150px;'},
	{key: 'start_date_contract', label: 'วันที่เริ่มทำสัญญา', _style: 'min-width:100px;'},
	{key: 'balance', label: 'ยอดเงินคงเหลือ', _style: 'min-width:100px; text-align: right;'},
	{key: 'cur_status_id', label: 'สถานะ', _style: 'min-width:100px;'},
	{key: 'process_day', label: 'เวลาดำเนินการ', _style: 'min-width:50px; text-align: center;'},
	{
		key: 'show_details',
		label: 'รายละเอียด',
		_style: 'min-width:150px; text-align: center;',
		sorter: false,
		filter: false
	}
]

export default {
	name: 'TransferLoan',
	data() {
		return {
			options: [],
			show: true,
			isCollapsed: true,
			items: [],
			fields,
			filterParams: {
				stepId: 5
			},
			searchParams: {
				keyword: '',
				startDate: '',
				endDate: '',
				filter: 0
			},
			privilege: {read: false, write: false, report: false}
		}
	},
	watch: {
		$route: {
			immediate: true,
			handler(route) {
				if (route.query && route.query.page) {
					this.activePage = Number(route.query.page)
				}
			}
		}
	},

	async mounted() {
		this.$store.state.loading = true
		try {
			this.searchParams.endDate = moment().format('YYYY-MM-DD')
			this.searchParams.startDate = moment().subtract(6, 'months').format('YYYY-MM-DD')
			await new Promise((resolve, reject) => {
				fetchFilter(this.filterParams).then(response => {
					const check = response.header
					const data = response.body
					if (check.error === 'N') {
						this.options = data

						console.log('filter : ', this.options);
						resolve()
					}
				}).catch(error => {
					this.errorMsg = error
					console.log(error)
					reject(error)
				})
			})
			await this.getMoneyTransferList()
		} finally {
			this.$store.state.loading = false
		}

		const check = func.checkMenu(this.$route.path)
		if (check && check.length > 0) {
			this.privilege = check[0]
		}
	},

	methods: {
		async getMoneyTransferList() {
			console.log('searchParams : ', this.searchParams);
			await fetchMoneyTransferList(this.searchParams).then(res => {
				this.items = []
				const check = res.header;
				const data = res.body;
				if (check.error == 'N') {
					for (let item of data) {
						if (item.cur_status_id == 2 && item.cur_step == 4) {
							item.cur_status_id = 'รอโอนเงินสินเชื่อ'
						} else if (item.cur_status_id == 0 && item.cur_step == 5) {
							item.cur_status_id = 'รอโอนเงินสินเชื่อ[ข้ามขั้นตอน]'
						} else if (item.cur_status_id == 5 && item.cur_step == 5) {
							item.cur_status_id = 'ขอเบิกก่อน'
						} else if (item.cur_status_id == 2 && item.cur_step == 5) {
							item.cur_status_id = 'โอนเงินสินเชื่อ[เรียบร้อย]'
						}
					}
					this.items = data;
					console.log('items : ', this.items);
				}
			}).catch(error => {
				Message({
					message: 'มีข้อผิดพลาด กรุณาติดต่อผู้ดูแลระบบ',
					type: 'error',
					duration: 5 * 1000,
				})
				this.errorMsg = error
				console.log(error)
			})
		},
		getBadge(status) {
			switch (status) {
				case 'โอนเงินสินเชื่อ[เรียบร้อย]':
					return 'success'
				// case 'Inactive': return 'secondary'
				case 'รอโอนเงินสินเชื่อ':
					return 'warning'
				case 'ขอเบิกก่อน':
					return 'info'
				default:
					return 'primary'
			}
		},
		handleContractExport() {
			const loading = this.$loading({
				lock: true,
				text: 'Please wait',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			})

			fetchReportStep5(this.searchParams).then(response => {
				const fileURL = window.URL.createObjectURL(new Blob([response]))
				const fileName = 'Step5_' + func.generateReportDate() + '.xlsx'
				const link = document.createElement('a')

				link.href = fileURL
				link.setAttribute('download', fileName)
				document.body.appendChild(link)
				loading.close()
				if (response.size > 0 && response.type !== 'application/json') {
					link.click()
				} else {
					this.$notify({
						title: 'Error',
						message: 'ไม่สามารถสร้างรายงานการโอนเงินสินเชื่อ',
						type: 'error',
						duration: 5000
					})
				}
				link.remove()

				// Just to simulate the time of the request
				setTimeout(() => {
					loading.close()
				}, 1.5 * 1000)
			})
		},
		rowClickDetail(item) {
			this.$router.push({path: `/step5/TransferLoanDetail/${item.contract_id}`})
		},
		pageChange(val) {
			this.$router.push({query: {page: val}})
		}
	}
}
